module.exports = __webpack_public_path__ + "img/RedditLight.4aa5c120.svg";